<template>
  <div class="card" ref="screen" v-if="viz1.visibleFlag === true && viz1.viztypeName!=='report'" :style="styles">
    <div class="card-header d-flex justify-content-between">
      <div class>{{viz1.vizTitle}}</div>

      <div v-on:click="fullscreen(showFSButton)">
        <i class="fas fa-expand-alt" style="color:blue" v-if="showFSButton"></i>
        <i class="fas fa-compress-alt" style="color:blue" v-if="!showFSButton"></i>
      </div>

      <a v-on:click="commentBox(viz1)" class="txt-color-white right-padding-50">
        <i class="fa fa-lg fa-comments"></i>
      </a>
    </div>
    <div class="card-body">
      <div :id="id" ref="r1c1" ></div>
    </div>

    <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
      <b-form-group label="Comment">
        <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
import {FwVizChartInfo} from "../models";
import axios from "axios";

export default {
        name: "Viz1",
        props: {
            viz1: Object,
            styles: String
        },
        data: () => ({
            showFSButton:true,
            showModal: false,
            cmnt: "",
            annotations: [],
            searching: false,
            annotationTitle: "",
        //    e: false,

            id: `VIZ-${new Date().getTime()}`,
        }),
        methods: {
            commentBox: function (what) {
                console.log(
                    `ENTERED into the commentBox function(${what.menuName}, ${what.screenName})`
                );
                this.cmt = "";
                this.pg = what.menuName;
                this.section = what.screenName;
                this.annotationHeader = "User Annotations";
                this.annotationTitle =
                this.annotationHeader + "->" + this.pg + "->" + this.section;
                this.$refs["comment-box"].show();
            },
            postAnnotation: function () {
                const url = "/api/annotation";
                const data = {
                    userId: 1,
                    userName: "Admin",
                    page: this.pg,
                    section: this.section,
                    comment: this.cmnt,
                };
                axios.post(url, data).then(() => {
                    this.$store.dispatch("loadAnnotations");
                },(e) => {
                    //  this.$commonFn.auditLog(this.viz1.menuSyspk,menu, subMenu, "", "POST", e);
                      console.error("error in updating annotations", e);
                 }
                );
                let menu = this.pg;
                let subMenu = this.section;
                console.log("the menus and submenus for Audit log is", menu, subMenu);

               // this.$commonFn.auditLog(this.viz1.menuSyspk,menu, subMenu, "", "POST", "Success");
            },
            fullscreen(showFSButton) {
                if(showFSButton===true) {
                    console.log(showFSButton)
                    this.$refs.screen.requestFullscreen();
                }
                else {
                    console.log(showFSButton)
                    const document=window.document
                    document.exitFullscreen();
                }
                this.showFSButton=!this.showFSButton
            }
        },
        created() {
            if(this.viz1.viztypeName !=='report'){
                console.log('v1','loading state');this.$store.dispatch("loadState").then(() => {
                    let allVizType = this.$store.state.vizType;
                    let v = this.viz1;
                    let margin = {
                        top: v.pmTop,
                        right: v.pmRight,
                        bottom: v.pmBottom,
                        left: v.pmLeft,
                    };

                    let vizId = v.viztypeId;
                    let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
                    let vizname = filter.viztypeClassName
                    let vizFunction = filter.viztypeFunctionName;
                    let divId = this.$refs.r1c1;
                    let vizunit = v.positionLogical;
                    console.log("vizName in vue",vizname)

                    let getChartInfo = (vizunit) => {
                        let f = v;
                        if (f.length === 0)
                          return new FwVizChartInfo(vizunit, margin, {}, false, []);
                        return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
                    };

                    this.position = getChartInfo(vizunit);

                    let chartData = this.position;
                    console.log("The chart data is", vizname, divId);

                    setTimeout(() => {
                        this.$commonFn.renderChart(
                          vizname,
                          chartData,
                          divId,
                          vizFunction,
                          this.myWidth
                        );
                    }, 300);
                });
            }
        },
    };
</script>
<style>
. cobackground {
  fill: #eee;
}
text.active {
  fill: red;
}
</style>